import { Navigate, Route, Routes } from "react-router-dom";
import { ReviewCreditsProvider } from "../hooks/useReviewCredits";
import { useUiState } from "../state";
import { StudioNewScanPage } from "./studio/StudioNewScanPage";
import { StudioProGate } from "./studio/StudioProGate";
import { StudioScanDetailPage } from "./studio/StudioScanDetailPage";
import { StudioScansListPage } from "./studio/StudioScansListPage";
import { StudioShell } from "./studio/StudioShell";
import { StudioMonitoringPage } from "./studio/StudioMonitoringPage";
import { StudioComparePage } from "./studio/StudioComparePage";

/**
 * Studio：/studio/* 共用侧栏+顶栏；扫描记录与详情在同一工作台内切换主内容区。
 */
export function StudioStandalonePage() {
  const { themeMode } = useUiState();
  const isDark = themeMode === "dark";

  return (
    <div
      className={
        isDark
          ? "studio-standalone-outer studio-standalone-outer-dark"
          : "studio-standalone-outer studio-standalone-light"
      }
    >
      <ReviewCreditsProvider>
        <Routes>
          <Route element={<StudioProGate />}>
            <Route element={<StudioShell />}>
              <Route index element={<Navigate to="new" replace />} />
              <Route path="new" element={<StudioNewScanPage />} />
              <Route path="scans" element={<StudioScansListPage />} />
              <Route path="scans/:scanId" element={<StudioScanDetailPage />} />
              <Route path="compare" element={<StudioComparePage />} />
              <Route path="monitoring" element={<StudioMonitoringPage />} />
            </Route>
          </Route>
        </Routes>
      </ReviewCreditsProvider>
    </div>
  );
}
